const columns = [
  {
    title: "Request type",
    dataIndex: "request_type_name",
    name: "request",
    scopedSlots: { customRender: "request" },
    width: 200,
  },
  {
    title: "Staff",
    dataIndex: "display_name",
    class: "cursor-pointer",
    scopedSlots: { customRender: "display_name" },
    width: 250,
  },
  {
    title: "Request Date",
    dataIndex: "request_date",
    scopedSlots: { customRender: "request_date" },
    align: "center",
    name: "request_date",
    width: 150,
  },
  {
    title: "Duration (Hour)",
    dataIndex: "quantity_in_hours",
    name: "duration_hour",
    customRender(value) {
      return toFixedNumber(value, 4);
    },
    align: "center",
    width: 120,
  },
  {
    title: "Reason type",
    dataIndex: "reason",
    name: "reason",
    width: 150,
    // scopedSlots: {customRender: "reason"}
  },
  {
    title: "Approver",
    dataIndex: "approver",
    name: "approver",
    scopedSlots: { customRender: "approver" },
    width: 250,
  },
  {
    title: "Status",
    dataIndex: "statusText",
    scopedSlots: { customRender: "statusText" },
    fixed: "right",
    align: "center",
    width: 150,
  },
  {
    title: "Action",
    dataIndex: "edit",
    scopedSlots: { customRender: "edit" },
    fixed: "right",
    align: "center",
    width: 80,
  },
];

const columnRequests = [
  {
    title: "Request Date",
    dataIndex: "requestDate",
  },
  {
    title: "Request hours",
    dataIndex: "requestHours",
  },
  {
    title: "Action",
    dataIndex: "action",
  },
];

import { DATE_FORMAT_V2_FULL, TIME_PM } from "@/utils";
import moment from "moment";
import { mapState } from "vuex";
import {
  CREATE_BY_HR,
  DATE_FORMAT_SHORT,
  DATE_FORMAT_V2,
  DURATION_TYPES,
  EXPLANATION_REFUND_BY_HOUR,
  FOLDER_NAME_LEAVE_REQUEST,
  REQUEST_TYPES,
  REQUEST_TYPE_HOUR,
  REQUEST_WORK_OUTSIDE,
  Role,
  SINGLE_TYPE,
  statusColor,
  statusName,
  statusText,
  TIME_STAFF,
  WORKING_TIME_ONSIDE_REQUEST
} from "../../components/commons/commonConstant";
import {
  checkShowWithLastTimesheet,
  convertObjectToParams,
  downloadFile,
  formatDate,
  formatTime,
  getInfoStaff,
  initFilters,
  scaleScreen,
  toFixedNumber,
} from "../../components/commons/commons";
import FilterLayout from "../../components/layouts/FilterLayout";
import ConfirmModal from "../../components/RequestManagement/ConfirmModal.vue";
import RequestModal from "../../components/RequestManagement/RequestModal.vue";
import http from "../../store/modules/helpers/httpInterceptor";
import ExplanationDetail from "./ExplanationDetail/ExplanationDetail.vue";
import RequestDetail from "./RequestDetail/RequestDetail.vue";
import { ImportModalRequest, ImportModalRequestRevoke } from "@/components";
import { getMessageResponseType, handleMessagesAPI } from "@/utils";

export default {
  name: "RequestManage",
  components: {
    RequestDetail,
    FilterLayout,
    ExplanationDetail,
    RequestModal,
    ConfirmModal,
    ImportModalRequest,
    ImportModalRequestRevoke
  },
  data() {
    return {
      page: "Request Management",
      currentScreen: "",
      columns,
      columnRequests,
      DURATION_TYPES,
      REQUEST_TYPES,
      statusColor,
      statusText,
      dataSource: [],
      currentPage: 1,
      pageSize: 10,
      total_items: 0,
      dataFilters: {},
      moment,
      filters: {},
      clickButtonEdit: false,
      visibleDrawer: false,
      visibleDrawerExplanation: false,
      Role,
      firstCall: true,
      visibleModal: false,
      isEdit: false,
      tempCheckDate: [],
      request_reasons: [],
      fetching: false,
      isCreated: false,
      isWorkOutSide: false,
      statusPayload: [],
      isApproved: false,
      startDate: {},
      endDate: {},
      disableExport: true,
      timeOut: null,
      size: window.outerWidth > 1000 ? window.outerWidth * 0.6 : window.outerWidth * 0.55,
      fileList: [],
      isVariableToDownLoad: false,
      request_type: "request",
      isClickAction: false,
      visibleModalRejectWithdraw: false,
      isReject: false,
      recordAction: {},
      type: SINGLE_TYPE,
      isLoading: false,
      requestTypeDay: REQUEST_TYPE_HOUR,
      explanationTypeDay: EXPLANATION_REFUND_BY_HOUR,
      requestTypeLog: REQUEST_TYPE_HOUR,
      explanationTypeLog: EXPLANATION_REFUND_BY_HOUR,
      folderName: FOLDER_NAME_LEAVE_REQUEST,
      visibleModalConfirm: false,
      isApprove: false,
      isLoadingPage: false,
      isShowModalImport: false,
      isShowModalImportRevoke: false,
      formUpdate: this.$form.createForm(this, { name: "updateHistory" }),
      requestDetailWidth: "30%",
    };
  },
  watch: {
    filters: function () {
      if (this.filters.fromDate !== undefined && this.filters.toDate !== undefined) {
        this.disableExport = false;
      } else {
        this.disableExport = true;
      }
    },
  },
  beforeCreate() {
    this.rejectWithdrawForm = this.$form.createForm(this, {
      name: "rejectWithdrawForm",
    });
  },
  async created() {
    this.requestTypeDay = this.userInfo.requestType || REQUEST_TYPE_HOUR;
    this.explanationTypeDay = this.userInfo.explanationType || EXPLANATION_REFUND_BY_HOUR;
    this.currentScreen = !this.roles.includes(Role.STAFF) ? "request_management" : "request_management_by_staff";
    // this.$store.dispatch("request/getParamsDataToSelect", "Request");
    this.scaleScreen();
    this.handFilters();
    this.firstCall = true;
    this.getLastTimesheetInfo();

    // Get Time Server
    this.$store.dispatch("application/getTimeServer");
    // Get most recent timesheet approved
    this.$store.dispatch("advance/getMostRecentTimeSheetApproved");
    window.addEventListener("resize", this.resize);
  },
  beforeMount() {
    this.isFlexible = this.userInfo.flexibleWorkSchedule;
  },
  mounted() {},
  computed: {
    ...mapState({
      roles: (state) => (state.user.userInfo.roles ? state.user.userInfo.roles : ""),
      employeeList: (state) => state.application.employeeList,
      userInfo: (state) => state.user.userInfo,
      dataRequestSelections: (state) => state.request.dataRequestSelections,
      lastTimesheet: (state) => state.application.lastTimesheet,
      dataActualFixed: (state) => state.abnormalcase.dataActualFixed,
      loading: (state) => state.user.loading,
      timeServer: (state) => state.application.timeServer,
      mostRecentTimeSheetApproved: (state) => state.advance.mostRecentTimeSheetApproved,
    }),
  },

  methods: {
    formatDate,
    formatTime,
    scaleScreen,
    getInfoStaff,
    // check show action summary
    checkTimeEditWithdraw(record) {
      return checkShowWithLastTimesheet(
        record.start_date,
        this.lastTimesheet?.last_timesheet_period_end_date,
        TIME_STAFF,
        DATE_FORMAT_SHORT,
        this.timeServer
      );
    },
    checkShowEdit(record) {
      return (
        (this.userInfo.userName === record.employee.user_name &&
        record.status_type === "PENDING" &&
        this.checkTimeEditWithdraw(record)) 
        || ((this.roles.includes(this.Role.ADMIN) || this.roles.includes(this.Role.HR) || this.roles.includes(this.Role.HRM)) && 
          record.status_type === "APPROVED" &&
          record.created_by_role === CREATE_BY_HR &&
          record.reason_type === WORKING_TIME_ONSIDE_REQUEST)
      );
    },
    checkShowWithdraw(record) {
      return (
        record.employee &&
        this.checkTimeEditWithdraw(record) &&
        this.userInfo.userName === record.employee.user_name &&
        (record.status_type === "PENDING" ||
          (record.status_type === "APPROVED" && !record.is_explanation && record.created_by_role !== CREATE_BY_HR))
      );
    },
    checkTimeApproveReject(record) {
      return checkShowWithLastTimesheet(
        record.start_date,
        this.mostRecentTimeSheetApproved,
        TIME_PM,
        DATE_FORMAT_SHORT,
        this.timeServer,
        DATE_FORMAT_V2_FULL
      );
    },

    checkShowReject(record) {
      return (
        this.checkTimeApproveReject(record) &&
        ((this.roles.includes(this.Role.HR) &&
          record.request_type === REQUEST_WORK_OUTSIDE &&
          record.status_type === "APPROVED" &&
          record.created_by_role === CREATE_BY_HR) ||
          (record.approver &&
            this.userInfo.userName === record.approver.user_name &&
            (((record.status_type === "APPROVED" || record.status_type === "PENDING") && !record.is_explanation) ||
              (record.status_type === "PENDING" && record.is_explanation))))
      );
    },
    checkShowApprove(record) {
      return (
        record.approver &&
        this.userInfo.userName === record.approver.user_name &&
        record.status_type === "PENDING" &&
        this.checkTimeApproveReject(record)
      );
    },

    checkMoreVisible(record) {
      return (
        this.checkShowReject(record) ||
        this.checkShowApprove(record) ||
        this.checkShowEdit(record) ||
        this.checkShowWithdraw(record)
      );
    },
    // Summary Request
    generateRequestDate(record) {
      const startDate = moment(record.start_date, DATE_FORMAT_SHORT).startOf("day");
      const endDate = moment(record.end_date, DATE_FORMAT_SHORT).startOf("day");
      if (startDate.isSame(endDate)) {
        return startDate.format(DATE_FORMAT_V2);
      } else {
        return `${startDate.format(DATE_FORMAT_V2)} - ${endDate.format(DATE_FORMAT_V2)}`;
      }
    },

    handleClickAction() {
      this.isClickAction = true;
    },
    handleOnClickEdit(i) {
      this.recordAction = i;
      this.visibleModal = true;
    },
    async showModalEdit(record) {
      this.recordAction = record;
      this.isEdit = true;
      this.type = "single";
      this.$store.dispatch("user/loadingRequest");
      this.$store
        .dispatch("application/getWorkScheduleUser", {
          userId: this.userInfo.userId,
          date: record?.start_date,
        })
        .then((res) => {
          this.requestTypeLog = res.request_type;
          this.explanationTypeLog = res.explanation_type;
        })
        .finally(() => {
          this.$store.dispatch("user/loadingRequest");
          this.visibleModal = true;
        });
    },
    showModalCreate(type) {
      // this.$router.push({ name: "Request Management Create" });
      this.type = type;
      this.requestTypeLog = this.requestTypeDay;
      this.explanationTypeLog = this.explanationTypeDay;
      this.visibleModal = true;
      this.isEdit = false;
    },
    handFilters() {
      const { filters, currentScreen, userInfo } = this;
      initFilters(filters, currentScreen, userInfo);
      if (sessionStorage.getItem(this.page)) {
        this.filters = { ...JSON.parse(sessionStorage.getItem(this.page)) };
      } else {
        this.filters = {
          ...this.filters,
          ...JSON.parse(sessionStorage.getItem(this.page)),
        };
      }
    },
    resize() {
      if (document.body.clientWidth > 1000) {
        this.size = document.body.clientWidth * 0.6;
      } else {
        this.size = document.body.clientWidth * 0.55;
      }
    },
    getData(res) {
      let data = [];
      // res.data.forEach((element, key) => {
      //   this.checkDateWithinApprovedTimesheet(element.start_date, key);
      // });
      setTimeout(() => {
        let temp = this.tempCheckDate;
        data = res.data.map((element, key) => {
          element.key = key;
          element.status_type = element.status_type.toUpperCase();
          element.duration_day = element.quantity_in_days;
          element.display_name = element.employee.name + " - " + element.employee.department_name.name;
          element.type = element.request_type_name_en ? element.request_type_name_en : "";
          element.reason = element.reason_type_name ? element.reason_type_name : "";
          element.from_date = formatDate(element.start_date);
          element.to_date = formatDate(element.end_date);
          element.last_modify_date = formatDate(element.last_modified_date)
            ? formatDate(element.last_modified_date)
            : null;
          temp.forEach((item) => {
            if (item.key === key) {
              element.checkDate = item.check;
            }
          });
          this.tempCheckDate = [];
          return element;
        });
        this.total_items = res.page.total_element;
        this.dataSource = data;
      }, 0);
      this.firstCall = false;
    },
    getRequestList() {
      const { currentPage, pageSize, filters } = this;
      let paramFilter = "";
      if (this.firstCall) {
        paramFilter = convertObjectToParams({ ...filters });
        this.currentPage = filters.page ? filters.page : 1;
        this.pageSize = filters.size ? filters.size : 10;
      } else {
        paramFilter = convertObjectToParams({
          ...filters,
          page: currentPage,
          size: pageSize,
        });
      }
      this.$store.dispatch("user/loadingRequest");
      this.$store.dispatch("request/getParamsDataToSelect", {
        screenType: "Request",
      });
      this.$store
        .dispatch("request/getRequestData", paramFilter)
        .then((res) => {
          if (parseInt(res.code) === 200 && res.data) {
            this.getData(res);
          } else {
            this.$message.error(res.message);
          }
        })
        .catch((error) => {
          this.$message.error(error.response.data.message);
        })
        .finally(() => {
          this.$store.commit("user/RESET_LOADING");
        });
      sessionStorage.setItem(
        this.page,
        JSON.stringify({
          ...filters,
          page: currentPage,
          size: pageSize,
        })
      );
    },

    customRow(record) {
      return {
        on: {
          click: () => {
            this.isVariableToDownLoad = false;
            this.fileList.splice(0, this.fileList.length);
            if (!this.isClickAction) {
              if (record.is_explanation) {
                this.visibleDrawerExplanation = true;
              } else {
                this.requestDetailWidth = record.reason_type === WORKING_TIME_ONSIDE_REQUEST ? "50%" : "30%";
                this.visibleDrawer = true;
              }
              this.recordAction = record;
              this.getAllListFile(record.id);
              if (record.reason_type === WORKING_TIME_ONSIDE_REQUEST) {
                this.getHistoryData(record.id);
              }
              this.onColumns = this.userList;
            } else {
              this.isClickAction = false;
            }
          },
        },
      };
    },
    formatHour(date) {
      return moment(date).format("HH:mm");
    },
    onChangePage(page, pageSize) {
      this.currentPage = page;
      this.pageSize = pageSize;
      this.getRequestList();
    },

    onApplyFilters(filters) {
      this.filters = filters;
      this.currentPage = 1;
      this.getRequestList();
    },
    onSetDataFilters(filters) {
      this.filters = filters;
    },
    // showDrawer() {
    //   this.visibleDrawer = true;
    // },
    onClose() {
      this.visibleDrawer = false;
      this.visibleDrawerExplanation = false;
    },
    handleCancel() {
      this.recordAction = null;
      this.visibleModal = false;
      this.requestTypeLog = this.requestTypeDay;
    },
    onSearchStaff(value, timeout) {
      let cloneVal = decodeURI(value);
      if (value && value !== "" && value.length >= 3) {
        this.fetching = true;
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.$store
            .dispatch("application/getEmployeeList", cloneVal)
            .then(() => {
              this.fetching = false;
            })
            .catch(() => {
              this.fetching = false;
            });
        }, timeout);
      }
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    /// getApprover
    getApprover() {
      return http
        .get("/tms/filters/get-approver-for-user?username=" + this.userInfo.userName)
        .then((res) => {
          this.approver = res.data;
        })
        .catch((err) => {
          throw err;
        });
    },

    updateStatus() {
      this.isLoading = true;
      this.$store
        .dispatch("request/updateStatusRequest", this.statusPayload)
        .then((res) => {
          if (res) {
            if (parseInt(res.code) === 200) {
              this.$message.success(res.message);
              this.visibleModalRejectWithdraw = false;
              this.visibleModalConfirm = false;
              this.rejectWithdrawForm.resetFields();
              this.isLoadingPage = false;
              this.hideDrawer();
              this.getRequestList();
            } else {
              this.isLoadingPage = false;
              this.$message.error(res.message);
            }
          }
        })
        .catch((err) => {
          this.isLoadingPage = false;
          this.$message.error(err.response.data.message);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onClickApprove(record, status) {
      this.statusPayload = {
        status_type: statusName[status],
        id: record.id ?? "",
      };
      this.isApprove = true;
      this.isLoadingPage = true;
      this.updateStatus();
      // this.visibleModalConfirm = true;
    },
    onClickReject(record, status) {
      this.statusPayload = {
        status_type: statusName[status],
        id: record.id ?? "",
      };
      this.visibleModalRejectWithdraw = true;
      this.isReject = true;
    },
    onClickWithDraw(record, status) {
      this.statusPayload = {
        status_type: statusName[status],
        id: record.id ?? "",
        status_update_type: record.status_type,
        request_dates: [
          {
            request_date: moment(record.from_date, "DD/MM/YYYY").startOf("day").format("YYYY-MM-DD HH:mm:ss"),
          }
        ]
      };
      if (record.is_explanation) {
        this.visibleModalRejectWithdraw = true;
      } else {
        this.isApprove = false;
        this.visibleModalConfirm = true;
      }
    },

    // Handle modal reject withdraw
    handleCancelRejectWithdraw() {
      this.visibleModalRejectWithdraw = false;
      this.rejectWithdrawForm.resetFields();
    },

    handleOk() {
      this.rejectWithdrawForm.validateFields((err, values) => {
        if (err) return;
        const { reason } = values;
        if (reason && reason.trim() !== "") {
          this.statusPayload.reason = reason;
          this.updateStatus();
        } else {
          this.rejectWithdrawForm.setFields({
            reason: { value: "", errors: [{ message: "Reason is required" }] },
          });
        }
      });
    },

    // Handle modal confirm
    handleOkConfirm() {
      this.updateStatus();
    },

    handleCancelConfirm() {
      this.visibleModalConfirm = false;
    },

    async checkDateWithinApprovedTimesheet(date, key) {
      const params = moment(date).format("YYYYMMDD").toString();
      await this.$store
        .dispatch("request/checkDateWithinApprovedTimesheet", params)
        .then((res) => {
          if (res) {
            this.tempCheckDate.push({ key: key, check: res.data });
          } else {
            this.$message.error(res.message, 5);
          }
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
        });
    },
    checkDateInCurrentTimeSheet(record) {
      const params = moment(record.created_date).format("YYYYMMDD").toString();
      this.$store
        .dispatch("request/checkDateWithinApprovedTimesheet", params)
        .then((res) => {
          this.getMessage(res);
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
        });
    },
    getLastTimesheetInfo() {
      this.$store
        .dispatch("application/getEndDateOfLastTimsheet")
        .then((res) => {
          this.getMessage(res);
        })
        .catch((error) => {
          this.$message.error(error.message, 5);
        });
    },
    getMessage(res) {
      if (!res) {
        this.$message.error(res.message, 5);
      }
    },

    getAllListFile(id) {
      const { fileList } = this;
      http
        .get(`/tms/request-management/${this.folderName}/get-all-file-list?id=` + id)
        .then((res) => {
          if (res.data) {
            let tempData = res.data;
            tempData.forEach((record) => {
              fileList.push(record);
            });
            if (fileList.length > 0) {
              this.isVariableToDownLoad = true;
            } else {
              this.isVariableToDownLoad = false;
            }
            return tempData;
          }
        })
        .catch((err) => {
          throw err;
        });
    },

    async getHistoryData(id) {
      try {
        await this.$store.dispatch("request/getHistoryData", { id: id });
      } catch (error) {
        handleMessagesAPI(error.response.data);
      }
    },

    exportRequest() {
      clearTimeout(this.timeOut);
      this.timeOut = setTimeout(() => {
        const { filters } = this;
        const paramFilter = convertObjectToParams({
          ...filters,
        });
        this.$store.dispatch("user/loadingRequest");
        http
          .get(`tms/excel/request-list${paramFilter}`, { responseType: "blob" })
          .then((res) => {
            if (res.status === 200 && res.data.type !== "application/json") {
              downloadFile(
                res.data,
                `Request_List_${moment(filters.fromDate).format("DD/MM/yyyy")}-${moment(filters.toDate).format(
                  "DD/MM/yyyy"
                )}.xlsx`
              );
              this.$store.dispatch("user/loadingRequest");
              this.$message.success("Request List is exported successfully!", 5);
            } else {
              this.$store.dispatch("user/loadingRequest");
              this.$message.error("No data export", 5);
            }
          })
          .catch(async (error) => {
            this.$store.dispatch("user/loadingRequest");
            if (error.request.responseType === "blob" && error.response.data instanceof Blob) {
              const errorObject = JSON.parse(await error.response.data.text());
              this.$message.error(errorObject.message, 5);
            }
          });
      }, 500);
    },
    importRequest() {
      clearTimeout(this.timeOut);
      this.isShowModalImport = true
    },
    importRequestRevoke() {
      clearTimeout(this.timeOut);
      this.isShowModalImportRevoke = true
    },
    hideDrawer() {
      this.visibleDrawer = false;
      this.visibleDrawerExplanation = false;
    },
    handleCancelRequest() {
      this.formUpdate.resetFields();

      this.isShowModalImport = false;
    },
    handleCancelRequestRevoke() {
      this.formUpdate.resetFields();

      this.isShowModalImportRevoke = false;
    },
    async onImport(values, onSuccess) {
      try {
        this.fetching = true;
        const res = await this.$store.dispatch("timesheet/importFileRequest", values);
        const { status } = res;
        handleMessagesAPI(res?.headers);
        if (status === 200) {
          this.$message.success("File Request TimeOff is imported successfully!", 5);
          onSuccess()
          this.handleCancelRequest();
        }
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        this.fetching = false;
      }
    },
    async onImportRevoke(values, onSuccess) {
      try {
        this.fetching = true;
        const res = await this.$store.dispatch("timesheet/importFileRequestRevoke", values);
        const { status } = res;
        handleMessagesAPI(res?.headers);
        if (status === 200) {
          this.$message.success("File Request TimeOff Revoke is imported successfully!", 5);
          onSuccess()
          this.handleCancelRequestRevoke();
        }
      } catch (error) {
        const errorObject = await getMessageResponseType(error);
        handleMessagesAPI(errorObject);
      } finally {
        this.fetching = false;
      }
    }
  },
  destroyed() {
    this.$store.commit("user/RESET_LOADING");
  },
  props: {
    msg: String,
  },
};
